import ProductEditor from './ProductEditor'
export default ProductEditor


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/index.js